// Payment methods
// Subscriptions

export default [
  {
    component: () => import('../pages/group.vue'),
    name: 'billing-group',
    path: '/:slug/billing/group',
  },
  {
    component: () => import('../pages/entity.vue'),
    name: 'billing-entity',
    path: '/:slug/billing/:billable_type/:billable_id',
  },
  /////////////////////////////////////////////////////////////////////////////
  // Payment methods
  /////////////////////////////////////////////////////////////////////////////
  {
    component: () => import('../pages/add-payment-method.vue'),
    name: 'billing-entity-add-payment-method',
    path: '/:slug/billing/:billable_type/:billable_id/add-payment-method',
  },
  {
    component: () => import('../pages/add-payment-method.vue'),
    name: 'billing-group-add-payment-method',
    path: '/:slug/billing/group/add-payment-method',
  },
  {
    component: () => import('../pages/remove-payment-method.vue'),
    name: 'billing-entity-remove-payment-method',
    path: '/:slug/billing/:billable_type/:billable_id/payment-method/:payment_method_id/remove',
  },
  {
    component: () => import('../pages/remove-payment-method.vue'),
    name: 'billing-group-remove-payment-method',
    path: '/:slug/billing/group/payment-method/:payment_method_id/remove',
  },
  {
    component: () => import('../pages/verify-payment-method.vue'),
    name: 'billing-entity-verify-payment-method',
    path: '/:slug/billing/:billable_type/:billable_id/verify-payment-method/:setup_intent_id',
  },
  {
    component: () => import('../pages/verify-payment-method.vue'),
    name: 'billing-group-verify-payment-method',
    path: '/:slug/billing/group/verify-payment-method/:setup_intent_id',
  },
  /////////////////////////////////////////////////////////////////////////////
  // Subscriptions
  /////////////////////////////////////////////////////////////////////////////
  {
    component: () => import('../pages/cancel-plan.vue'),
    name: 'billing-cancel-plan',
    path: '/:slug/billing/subscription/:subscription_id/cancel',
  },
  {
    component: () => import('../pages/change-plan.vue'),
    name: 'billing-change-plan',
    path: '/:slug/billing/subscription/:subscription_id/change',
  },
  {
    component: () => import('../pages/select-plan.vue'),
    name: 'billing-group-select-plan',
    path: '/:slug/billing/group/select-plan',
  },
]
